import React, { useState, useEffect, useRef, lazy, Suspense } from "react";
import Grid from "@mui/system/Unstable_Grid/Grid";

import DashDateRangeComponent from "../../reuseableComponents/DashDateRangeComponent";
import VerticalBarChart from "../Dashboard/VerticalBarChart";
import "./NewSalesReportMain.css";
import "../../Styles/SalesSummaryWorkspace.css";
import "../../Styles/SalesReportsWorkspace.css";
import { Download, Printer, Loader2 } from "lucide-react";

import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  AttachMoney,
  TrendingUp,
  TrendingDown,
  ShoppingCart,
  People,
  ReceiptLong,
  CardGiftcard,
  Replay,
  CreditCard,
  Calculate,
  Payments,
  VolunteerActivism,
  SouthWest,
  AccountBalanceWallet,
  // Download,
  Print,
  ErrorOutline,
  CheckCircleOutline,
  CalendarMonth
} from "@mui/icons-material";
import { CSVLink } from "react-csv";
import SalesReportHeader from "./SalesReportHeader";
import { Skeleton } from "@mui/material";
import { useAuthDetails } from "../../Common/cookiesHelper";
import ExportReportModal from "../../reuseableComponents/ExportReportModal";
import { endPointObj } from "../../Constants/utils";
import printPage from "../../helperFunctions/printPage";
import { exportReportToNative } from "../../helperFunctions/exportReport";
import axios from "axios";
import Config from "../../Constants/Config";

const SalesReportMain = lazy(
  () => import("../Reporting/SalesReport/SalesReportMain")
);
const LocationMain = lazy(() => import("./Location/LocationMain"));
const CategoryMain = lazy(() => import("./Category/CategoryMain"));
const VendorsMain = lazy(() => import("./Vendors/VendorsMain"));
const EmployeeSalesMain = lazy(
  () => import("./EmployeeSales/EmployeeSalesMain")
);
const CustomerReportMain = lazy(() => import("./Customer/CustomerReportMain"));
const DiscountReportMain = lazy(() => import("./Discount/DiscountReportMain"));
const DiscountReportMainOld = lazy(
  () => import("./Discount/DiscountReportMainOld")
);
const SalesByHourMain = lazy(
  () => import("../Reporting/SalesReport/SalebyHour/SalebyHourMain")
);
const ItemsMain = lazy(() => import("../Reporting/ItemSales/MainItemSales"));
const DailySalesTotalNew = lazy(() => import("../Reporting/DailySalesTotalNew/DailySalesTotalNew"));
const SalesByCategoryReportNew = lazy(() => import("../Reporting/SalesByCategoryReportNew/SalesByCategoryReportNew"));
const HourlySalesReportNew = lazy(() => import("../Reporting/HourlySalesReportNew/HourlySalesReportNew"));
const SalesItemsNew = lazy(() => import("../Reporting/SalesItemNew/SalesItemNew"));
const DailyTotalsMain = lazy(
  () => import("../Reporting/DailyReport/DailyTtlReport")
);
const OrderTypeMain = lazy(() => import("../Reporting/ItemType/MainItem"));
const DetailedcategoryMain = lazy(
  () => import("../Reporting/CategoryDetails/MainCatedetails")
);
const DetailedcategoryMainOld = lazy(
  () => import("../Reporting/CategoryDetails/MainCatedetailsOld")
);
const DetailedsalespersonMain = lazy(
  () => import("../Reporting/SalesByPerson/MainSalesPerson")
);
const TopsellerMain = lazy(
  () => import("../Reporting/TopSaller/TopSallerReport")
);
const TopsellerMainOld = lazy(
  () => import("../Reporting/TopSaller/TopSallerReportOld")
);
const OrderefundreportMain = lazy(
  () => import("../Reporting/OrderRefundReport/OrderRefundReportMain")
);
const ItemrefundreportMain = lazy(
  () => import("../Reporting/RefundSummary/RefundSummary")
);
// const TipreportMain = lazy(
//   () => import("../Reporting/TipReport/TipReportMain")
// );
const CouponreportMain = lazy(
  () => import("../Reporting/CouponReport/CouponReportMain")
);
// Fact-table twin of the screen above. It lives at its OWN url rather than
// sharing one behind ?source=, because unlike the other twins it is not a
// like-for-like swap: the Outlet picker actually filters here, so the two
// screens can legitimately disagree for a multi-location merchant and both
// need to stay reachable side by side while that is checked.
const CouponreportNewMain = lazy(
  () => import("../Reporting/CouponReportNew/CouponReportNewMain")
);
const EmployeesalespercategoryreportMain = lazy(
  () =>
    import("../Reporting/EmployeeSalesPerCategory/MainEmployeeSalesPerCategory")
);
const CategorySalesSummeryReportMain = lazy(
  () =>
    import("../Reporting/CategorySalesSummeryReport/categorySalesSummeryMain")
);
const DropCashMain = lazy(() => import("../Reporting/DropCash/DropCashMain"));
const PayInMain = lazy(() => import("../Reporting/PayIn/PayInMain"));
const PaymentMethod = lazy(
  () => import("../Reporting/PaymentMehodDetail/PaymentMethodReport")
);
const ProductProfitability = lazy(
  () => import("../Reporting/itemSalesProfitRecord/items_sales_profit_record")
);
const OldSalesSummeryReport = lazy(
  () => import("../Reporting/Old Salse Summery/OldSalesReportMain")
);
const EmployeeAvgOrderValue = lazy(
  () =>
    import("../Reporting/itemSalesProfitRecord/NewItems_sales_profit_record")
);
const OwnerReportMain = lazy(() => import("../Reporting/OwnerReport/OwnerReportMain"));
const OwnerReportSetup = lazy(() => import("../Reporting/OwnerReport/OwnerReportSetup"));
const NewSalesByOrderTypeMain = lazy(
  () =>
    import(
      "../Reporting/NewSalesByOrderType/NewSalesByOrderTypeMain"
    )
);

// Four reports exist twice: the PHP-backed original and the fact-table screen
// built to replace it. Both sit at the SAME url, and ?source= picks the
// non-default one. All four serve the fact table and opt back to PHP with
// ?source=old. Category Sales (Detailed) used to be the other way round, so
// its old ?source=new links still land on the fact table: an unmatched marker
// falls back to the default entry. renderComponent below decides each default.
const REPORT_SOURCE_PARAM = "source";
const OLD_REPORT_SOURCE = "old";
const NEW_REPORT_SOURCE = "new";
const REPORT_SOURCES = [OLD_REPORT_SOURCE, NEW_REPORT_SOURCE];

// A dropdown entry is identified by url AND source, since the pair sharing a
// url is told apart only by the latter. A source with no entry of its own
// falls back to the url's default entry, matching what renderComponent does
// with a marker that report has no twin for.
const findReport = (url, source) => {
  const allReports = [...selectReportList, ...superadminReportList];
  return (
    allReports.find(
      (item) => item.url === url && (item.source || null) === (source || null)
    ) || allReports.find((item) => item.url === url && !item.source)
  );
};

// Path + ?source=<marker> for a twin entry, bare path for everything else.
const reportPath = (item) =>
  `/store-reporting/new-sale-report/${item.url}` +
  (item.source ? `?${REPORT_SOURCE_PARAM}=${item.source}` : "");

const selectReportList = [
  {
    title: "Overall Sales Summary",
    url: "sales-summary",
    className: "Sales-Summary-for-android",
  },
  {
    title: "Daily Sales Totals",
    url: "daily-sales-totals",
    className: "Daily-Sales-Totals-for-android",
  },
  {
    title: "Hourly Sales Report",
    url: "hourly-sales-report",
    className: "Hourly-Sales-Report-for-android",
  },
  {
    title: "Category Sales (Detailed)",
    url: "detailed-category-report",
    className: "Detailed-Category-Report-for-android",
  },
  {
    title: "Sales by Item",
    url: "sales-items",
    className: "Sales-Items-for-android",
  },
  {
    title: "Sales by Category",
    url: "sales-by-category",
    className: "Sales-by-Category-New-for-android",
  },
  {
    title: "Top-Selling Products",
    url: "top-seller",
    className: "Top-Sellers-for-android",
  },
  {
    title: "Sales by Order Type",
    url: "new-sales-by-order-type",
    className: "New-Sales-by-Order-Type-for-android",
  },
  {
    title: "Discounts Report",
    url: "discount",
    className: "Discount-for-android",
  },
  {
    title: "Coupons Used Report",
    url: "coupon-report",
    className: "Coupon-Report-for-android",
  },
  // {
  //   title: "Tip Report",
  //   url: "tip-report",
  //   className: "Tip-Report-for-android",
  // },
  // {
  //   title: "Location",
  //   url: "location",
  //   className:"Location-for-android"
  // },
  // {
  //   title: "Vendors",
  //   url: "vendors",
  //   className: "Vendors-for-android",
  // },
  // {
  //   title: "Employee Sales",
  //   url: "employee-sales",
  // },
  // {
  //   title: "Customer",
  //   url: "customer",
  // },

  // {
  //   title: "Order Refund Report",
  //   url: "order-refund-report",
  // },
  // {
  //   title: "Item Refund Report",
  //   url: "item-refund-report",
  // },

  // {
  //   title: "Employee Sales Per Category Report",
  //   url: "employee-sales-per-category-report",
  // },
  // {
  //   title: "Category Sales Summary Report",
  //   url: "category-sales-summary-report",
  // },
  // {
  //   title: "Drop Cash",
  //   url: "drop-cash",
  // },
  // {
  //   title: "Pay In Report",
  //   url: "pay-in-report",
  // },
  // {
  //   title: "Payment Method Details",
  //   url: "payment-method-details",
  // },
  // {
  //   title: "Product Profitability Report",
  //   url: "product-profitability-report",
  // },
];

const superadminReportList = [
  // {
  //   title: "Hourly Sales Report (Old)",
  //   url: "hourly-sales-report-old",
  //   className: "Sales-by-Hour-for-android superadminGreen",
  // },
  // {
  //   title: "Daily Sales Totals (Old)",
  //   url: "daily-sales-totals-old",
  //   className: "Daily-Totals-for-android superadminGreen",
  // },
  // {
  //   title: "Sales by Item (Old)",
  //   url: "sales-items-old",
  //   className: "Items-for-android superadminGreen",
  // },
  // {
  //   title: "Sales by Category (Old)",
  //   url: "category",
  //   className: "Category-for-android superadminGreen",
  // },
  // {
  //   title: "Category Sales Summary Report",
  //   url: "category-sales-summary-report",
  //   className: "Category-Sales-Summary-Report-for-android superadminGreen",
  // },
  // {
  //   title: "Drop Cash",
  //   url: "drop-cash",
  //   className: "Drop-Cash-Report-for-android",
  // },
  // {
  //   title: "Pay In Report",
  //   url: "pay-in-report",
  //   className: "Pay-In-Report-for-android",
  // },
  // {
  //   title: "Payment Method Details",
  //   url: "payment-method-details",
  //   className: "Payment-Method-Details-for-android",
  // },
  // The PHP variant of the reports that exist twice. Each shares its url with
  // the fact-table entry in the main dropdown and is reached with ?source=old.
  {
    title: "Category Sales (Detailed - Old)",
    url: "detailed-category-report",
    source: OLD_REPORT_SOURCE,
    className: "Detailed-Category-Report-Old-for-android superadminGreen",
  },
  // {
  //   title: "Top-Selling Products (Old)",
  //   url: "top-seller",
  //   source: OLD_REPORT_SOURCE,
  //   className: "Top-Sellers-Old-for-android superadminGreen",
  // },
  // {
  //   title: "Discounts Report (Old)",
  //   url: "discount",
  //   source: OLD_REPORT_SOURCE,
  //   className: "Discount-Old-for-android superadminGreen",
  // },
  // {
  //   title: "Coupons Used Report (Old)",
  //   url: "coupon-report",
  //   source: OLD_REPORT_SOURCE,
  //   className: "Coupon-Report-Old-for-android superadminGreen",
  // },
  {
    title: "Product Profitability",
    url: "product-profitability-report",
    className: "Product-Profitability-Report-for-android superadminGreen",
  },
  // {
  //   title: "Detailed Sales Person Report",
  //   url: "detailed-sales-person-report",
  //   className: "Detailed-Sales-Person-Report-for-android superadminGreen",
  // },
  // {
  //   title: "Old Sales Summary Report",
  //   url: "old-salesSummary-report",
  //   className: "Old-Sales-Summary-Report-for-android superadminGreen",
  // },
  {
    title: "Employee Average Order Value",
    url: "Employee-Avg-Order-Value-report",
    className: "Employee-Avg-Order-Value-Report-for-android superadminGreen",
  },
  {
    title: "Owner Report",
    url: "owner-report",
    className: "Owner-Report-for-android superadminGreen !hidden",
  },
  {
    title: "Owner Report Setup",
    url: "owner-report-setup",
    className: "Owner-Report-Setup-for-android superadminGreen !hidden",
  },
];
// The Owner Report as merchants see it, once a superadmin has enabled it for
// their stores (superadmins see the green entry in superadminReportList).
const ownerReportMerchantEntry = {
  title: "Owner Report",
  url: "owner-report",
  className: "Owner-Report-for-android !hidden",
};

const NewSalesReportMain = () => {
  const navigate = useNavigate();
  const { userTypeData, LoginGetDashBoardRecordJson } = useAuthDetails();
  const isSuperadmin = userTypeData?.login_type === "superadmin";
  const ownerReportMerchantId = LoginGetDashBoardRecordJson?.data?.merchant_id || "";
  // Owner Report for a merchant login: hidden until the API says a superadmin
  // enabled it for this store's owner (the API refuses the figures otherwise).
  const [ownerReportEnabled, setOwnerReportEnabled] = useState(false);
  useEffect(() => {
    if (isSuperadmin || !ownerReportMerchantId) return undefined;
    let cancelled = false;
    const { token, ...fields } = userTypeData || {};
    axios
      .post(
        Config.REPORTS_BASE_URL + Config.OWNER_REPORT_ACCESS_API,
        { merchant_id: ownerReportMerchantId, ...fields },
        { headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}` } }
      )
      .then((res) => !cancelled && setOwnerReportEnabled(!!res?.data?.allowed))
      .catch(() => !cancelled && setOwnerReportEnabled(false));
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuperadmin, ownerReportMerchantId]);
  const { selectedReport } = useParams();
  const [searchParams] = useSearchParams();
  // Only a known marker selects a twin; anything else falls through to the
  // report's default variant rather than rendering nothing.
  const rawReportSource = searchParams.get(REPORT_SOURCE_PARAM);
  const activeReportSource = REPORT_SOURCES.includes(rawReportSource)
    ? rawReportSource
    : null;
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [CSVData, setCSVData] = useState(null);
  const [CSVHeaders, setCSVHeader] = useState(null);
  const [CSVFileName, setCSVFileName] = useState("");
  const [openModal, setOpenModal] = useState(false);
  // Reports whose Export fetches on click (Sales by Item, Category Sales
  // (Detailed)) expose exportCsv() here instead of filling CSVData.
  const reportExportRef = useRef(null);
  const [reportExporting, setReportExporting] = useState(false);
  // True while Sales by Category is showing a category's item drill-down,
  // which has nothing of its own to export - see the note in that component.
  const [categoryDrillDownOpen, setCategoryDrillDownOpen] = useState(false);
  const onDateRangeChange = (dateRange) => {
    setSelectedDateRange(dateRange);
  };
  const formatDate = (date) => {
    return new Intl.DateTimeFormat("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(date);
  };
  const formatDisplayDate = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(new Date(Number(year), Number(month) - 1, Number(day)));
  };
  const [selectedReportList, setSelectedReportList] = useState(
    "Overall Sales Summary"
  );
  useEffect(() => {
    if (!selectedReport) {
      navigate("/store-reporting/new-sale-report/sales-summary", {
        replace: true,
      });
      return;
    }

    if (selectedReport === "hourly-sales-report-new") {
      navigate("/store-reporting/new-sale-report/hourly-sales-report", {
        replace: true,
      });
      return;
    }

    if (selectedReport === "daily-sales-totals-new") {
      navigate("/store-reporting/new-sale-report/daily-sales-totals", {
        replace: true,
      });
      return;
    }

    if (selectedReport === "sales-by-hour") {
      navigate("/store-reporting/new-sale-report/hourly-sales-report-old", {
        replace: true,
      });
      return;
    }

    if (selectedReport === "daily-totals") {
      navigate("/store-reporting/new-sale-report/daily-sales-totals-old", {
        replace: true,
      });
      return;
    }

    if (
      selectedReport === "hourly-sales-report-old" &&
      userTypeData?.login_type !== "superadmin"
    ) {
      navigate("/store-reporting/new-sale-report/hourly-sales-report", {
        replace: true,
      });
      return;
    }

    if (
      selectedReport === "daily-sales-totals-old" &&
      userTypeData?.login_type !== "superadmin"
    ) {
      navigate("/store-reporting/new-sale-report/daily-sales-totals", {
        replace: true,
      });
      return;
    }

    if (selectedReport === "sales-items-new") {
      navigate("/store-reporting/new-sale-report/sales-items", {
        replace: true,
      });
      return;
    }

    if (selectedReport === "items") {
      navigate("/store-reporting/new-sale-report/sales-items-old", {
        replace: true,
      });
      return;
    }

    if (
      selectedReport === "sales-items-old" &&
      userTypeData?.login_type !== "superadmin"
    ) {
      navigate("/store-reporting/new-sale-report/sales-items", {

        replace: true,
      });
      return;
    }

    if (
      selectedReport === "category" &&
      userTypeData?.login_type !== "superadmin"
    ) {
      navigate("/store-reporting/new-sale-report/sales-by-category", {
        replace: true,
      });
      return;
    }

    if (selectedReport === "sales-by-category-new") {
      navigate("/store-reporting/new-sale-report/sales-by-category", {
        replace: true,
      });
      return;
    }

    if (selectedReport === "coupon-report-new") {
      navigate("/store-reporting/new-sale-report/coupon-report", {
        replace: true,
      });
      return;
    }

    setSelectedReportList(findReport(selectedReport, activeReportSource)?.title);
    setCSVData([]);
    setCSVHeader([]);
    setCSVFileName("");
  }, [
    navigate,
    selectedReport,
    activeReportSource,
    userTypeData?.login_type,
  ]);

  useEffect(() => {
    if (selectedReport !== "sales-summary") return;
    if (selectedDateRange) return;
    const merchantId = LoginGetDashBoardRecordJson?.data?.merchant_id;
    if (!merchantId) return;
    const today = formatDate(new Date());
    setSelectedDateRange({
      start_date: today,
      end_date: today,
      outlet_ids: merchantId,
    });
  }, [selectedReport, selectedDateRange, LoginGetDashBoardRecordJson]);

  const handleOptionClick = (option, dropdown) => {
    switch (dropdown) {
      case "reportList":
        setSelectedReportList(option.title);
        navigate(reportPath(option));
        break;

      default:
        break;
    }
  };

  const renderComponent = () => {
    console.log("Case", selectedReport);
    switch (selectedReport) {
      case "sales-summary":
        return (
          <SalesReportMain
            hide={true}
            workspace={true}
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            setCSVFileName={setCSVFileName}
            selectedDateRange={selectedDateRange}
            setSelectedDateRange={setSelectedDateRange}
            onDateRangeChange={onDateRangeChange}
          />
        );
      case "location":
        return <LocationMain hide={true} />;
      case "category":
        return (
          <CategoryMain
            hide={true}
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            setCSVFileName={setCSVFileName}
          />
        );
      // case "vendors":
      //   return (
      //     <VendorsMain
      //       hide={true}
      //       setCSVData={setCSVData}
      //       setCSVHeader={setCSVHeader}
      //       setCSVFileName={setCSVFileName}
      //     />
      //   );
      case "employee-sales":
        return (
          <EmployeeSalesMain
            hide={true}
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
          />
        );
      case "customer":
        return (
          <CustomerReportMain
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            hide={true}
            selectedDateRange={selectedDateRange}
          />
        );
      case "discount":
        // Defaults to the fact table like Top-Selling Products: the PHP screen
        // is behind ?source=old.
        return activeReportSource === OLD_REPORT_SOURCE ? (
          <DiscountReportMainOld
            hide={true}
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            setCSVFileName={setCSVFileName}
          />
        ) : (
          <DiscountReportMain
            hide={true}
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            setCSVFileName={setCSVFileName}
          />
        );
      case "hourly-sales-report":
      case "hourly-sales-report-new":
        return (
          <HourlySalesReportNew
            hide={false}
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            setCSVFileName={setCSVFileName}
          />
        );
      case "hourly-sales-report-old":
      case "sales-by-hour":
        return (
          <SalesByHourMain
            hide={true}
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            setCSVFileName={setCSVFileName}
          />
        );
      case "items":
      case "sales-items-old":
        return (
          <ItemsMain
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            hide={true}
            setCSVFileName={setCSVFileName}
          />
        );
      case "daily-sales-totals":
      case "daily-sales-totals-new":
        return (
          <DailySalesTotalNew
            hide={false}
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            setCSVFileName={setCSVFileName}
          />
        );
      case "sales-items":
      case "sales-items-new":
        return (
          <SalesItemsNew
            hide={true}
            ref={reportExportRef}
            onExportingChange={setReportExporting}
          />
        );
      case "sales-by-category":
        return (
          <SalesByCategoryReportNew
            hide={false}
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            setCSVFileName={setCSVFileName}
            onDrillDownChange={setCategoryDrillDownOpen}
          />
        );
      case "daily-sales-totals-old":
      case "daily-totals":
        return (
          <DailyTotalsMain
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            hide={true}
            setCSVFileName={setCSVFileName}
            type={"daily-totals"}
          />
        );
      case "order-type":
        return (
          <OrderTypeMain
            hide={true}
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            setCSVFileName={setCSVFileName}
          />
        );
      case "new-sales-by-order-type":
        return (
          <NewSalesByOrderTypeMain
            hide={true}
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            setCSVFileName={setCSVFileName}
          />
        );

      case "detailed-category-report":
        // Defaults to the fact table, like Top-Selling Products below; PHP is
        // behind ?source=old. The retired ?source=new also gets the fact table.
        return activeReportSource === OLD_REPORT_SOURCE ? (
          <DetailedcategoryMainOld
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            hide={true}
            setCSVFileName={setCSVFileName}
          />
        ) : (
          <DetailedcategoryMain
            hide={true}
            exportRef={reportExportRef}
            onExportingChange={setReportExporting}
          />
        );
      case "detailed-sales-person-report":
        return (
          <DetailedsalespersonMain
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            setCSVFileName={setCSVFileName}
            hide={true}
          />
        );
      case "top-seller":
        return activeReportSource === OLD_REPORT_SOURCE ? (
          <TopsellerMainOld
            hide={true}
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            setCSVFileName={setCSVFileName}
          />
        ) : (
          <TopsellerMain
            hide={true}
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            setCSVFileName={setCSVFileName}
          />
        );
      case "order-refund-report":
        return (
          <OrderefundreportMain
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            hide={true}
            setCSVFileName={setCSVFileName}
          />
        );

      case "item-refund-report":
        return (
          <ItemrefundreportMain
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            hide={true}
            setCSVFileName={setCSVFileName}
          />
        );

      // case "tip-report":
      //   return (
      //     <TipreportMain
      //       hide={true}
      //       setCSVData={setCSVData}
      //       setCSVHeader={setCSVHeader}
      //       setCSVFileName={setCSVFileName}
      //     />
      //   );
      case "coupon-report":
        // Defaults to the fact table like Discounts: the PHP screen is behind
        // ?source=old.
        return activeReportSource === OLD_REPORT_SOURCE ? (
          <CouponreportMain
            hide={true}
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            setCSVFileName={setCSVFileName}
          />
        ) : (
          <CouponreportNewMain
            hide={true}
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            setCSVFileName={setCSVFileName}
          />
        );
      case "employee-sales-per-category-report":
        return (
          <EmployeesalespercategoryreportMain
            hide={true}
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            setCSVFileName={setCSVFileName}
          />
        );

      case "category-sales-summary-report":
        return (
          <CategorySalesSummeryReportMain
            hide={true}
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            setCSVFileName={setCSVFileName}
          />
        );
      case "drop-cash":
        return (
          <DropCashMain
            hide={true}
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            setCSVFileName={setCSVFileName}
          />
        );
      case "pay-in-report":
        return (
          <PayInMain
            hide={true}
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            setCSVFileName={setCSVFileName}
          />
        );

      case "payment-method-details":
        return (
          <PaymentMethod
            hide={true}
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            setCSVFileName={setCSVFileName}
          />
        );
      case "product-profitability-report":
        return (
          <ProductProfitability
            hide={true}
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            setCSVFileName={setCSVFileName}
          />
        );
      case "old-salesSummary-report":
        return (
          <OldSalesSummeryReport
            hide={true}
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            setCSVFileName={setCSVFileName}
          />
        );
      case "owner-report":
        return <OwnerReportMain />;
      case "owner-report-setup":
        return isSuperadmin ? <OwnerReportSetup /> : null;
      case "Employee-Avg-Order-Value-report":
        return (
          <EmployeeAvgOrderValue
            hide={true}
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            setCSVFileName={setCSVFileName}
          />
        );

      default:
        return (
          <SalesReportMain
            hide={true}
            setCSVData={setCSVData}
            setCSVHeader={setCSVHeader}
            setCSVFileName={setCSVFileName}
            selectedDateRange={selectedDateRange}
            setSelectedDateRange={setSelectedDateRange}
            onDateRangeChange={onDateRangeChange}
          />
        );
    }
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const isNewSalesByOrderType = selectedReport === "new-sales-by-order-type";

  const isSalesSummary = selectedReport === "sales-summary";
  console.log(isSalesSummary, "........")

  const currentReportTitle =
    findReport(selectedReport, activeReportSource)?.title || "Sales by Item";

  const reportSubtitles = {
    "hourly-sales-report": "Track your store's performance throughout the day",
    "sales-items": "View detailed sales metrics for each item",
    "daily-totals": "Track your store's daily sales performance",
    "category": "Track sales performance across all product categories",
  };
  const currentReportSubtitle = reportSubtitles[selectedReport];

  return (
    <div
      style={
        !isNewSalesByOrderType && !isSalesSummary
          ? { display: "contents" }
          : undefined
      }
      className={
        [
          "qv-sales-reports-workspace",
          isNewSalesByOrderType
            ? "bg-[#F8FAFC] rounded-none sm:rounded-lg -mx-2 sm:mx-0 px-2 sm:px-0 pb-6"
            : "",
          isSalesSummary ? "qv-sales-summary-workspace" : "",
        ]
          .filter(Boolean)
          .join(" ")
      }
    >
      <SalesReportHeader
        title={
          isNewSalesByOrderType
            ? "Sales by Order Type"
            : isSalesSummary
              ? "Overall Sales Summary"
              : currentReportTitle
        }
        subtitle={
          isNewSalesByOrderType
            ? "Track and analyze your sales performance"
            : isSalesSummary
              ? "Comprehensive overview of business performance"
              : currentReportSubtitle
        }
        printNote={
          isSalesSummary &&
            selectedDateRange?.start_date &&
            selectedDateRange?.end_date ? (
            <p className="qv-sales-summary-header__print-date-range hidden print:block text-gray-500 font-medium mt-2 mb-2 text-xs sm:text-sm">
              {formatDisplayDate(selectedDateRange.start_date)} -{" "}
              {formatDisplayDate(selectedDateRange.end_date)}
            </p>
          ) : null
        }
        reportList={
          userTypeData?.login_type !== "superadmin"
            ? ownerReportEnabled
              ? [...selectReportList, ownerReportMerchantEntry]
              : selectReportList
            : [...selectReportList, ...superadminReportList]
        }
        selectedReport={selectedReportList}
        onReportChange={handleOptionClick}
        actions={
          <>
            {isSalesSummary && (
              <button
                type="button"
                onClick={printPage}
                className="qv-sales-summary-action qv-sales-summary-action--print print:hidden"
              >
                <Printer className="w-4 h-4" />
                Print
              </button>
            )}
            {selectedReport === "sales-items" ||
            selectedReport === "sales-items-new" ||
            (selectedReport === "detailed-category-report" &&
              activeReportSource !== OLD_REPORT_SOURCE) ? (
              <button
                type="button"
                onClick={() => reportExportRef.current?.exportCsv()}
                disabled={reportExporting}
                className="export-report-android inline-flex"
              >
                {reportExporting ? (
                  <span className="inline-flex items-center justify-center gap-1.5">
                    <Loader2 className="w-4 h-4 animate-spin" />
                    Exporting...
                  </span>
                ) : (
                  <span className="inline-flex items-center justify-center gap-1.5">
                    <Download className="w-4 h-4" />
                    Export
                  </span>
                )}
              </button>
            ) : (
              CSVData &&
              CSVHeaders.length > 0 &&
              !(categoryDrillDownOpen && !isNewSalesByOrderType && !isSalesSummary) && (
                <CSVLink
                  data={CSVData}
                  className="export-report-android inline-flex print:hidden"
                  headers={CSVHeaders}
                  filename={CSVFileName}
                  onClick={() =>
                    !exportReportToNative(CSVData, CSVHeaders, CSVFileName)
                  }
                >
                  <span className="inline-flex items-center justify-center gap-1.5">
                    <Download className="w-4 h-4" />
                    Export
                  </span>
                </CSVLink>
              )
            )}
          </>
        }
      />
      {/* <Grid container sx={{ paddingY: 3.7 }}>
        <Grid item xs={12}>
          <DashDateRangeComponent onDateRangeChange={onDateRangeChange} />
        </Grid>
      </Grid> */}

      <Grid container>
        <Grid item xs={12}>
          <Suspense
            fallback={
              <>
                <Grid
                  container
                  className="box_shadow_div_EA"
                  sx={{ mt: 2.5, p: 2 }}
                >
                  <Grid item xs={12}>
                    <Skeleton height={200} width={"100%"} />
                  </Grid>
                </Grid>
                <Grid
                  container
                  className="box_shadow_div_EA"
                  sx={{ mt: 2.5, mx: 0 }}
                  spacing={2}
                >
                  <Grid item xs={12} sm={6}>
                    <Skeleton height={200} width={"100%"} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Skeleton height={200} width={"100%"} />
                  </Grid>
                </Grid>

                <Grid
                  container
                  className="box_shadow_div_EA"
                  sx={{ mt: 3.5, p: 2.5 }}
                >
                  <Grid item xs={12}>
                    <Skeleton height={200} width={"100%"} />
                  </Grid>
                </Grid>
              </>
            }
          >
            {renderComponent()}
          </Suspense>
        </Grid>
      </Grid>

      <ExportReportModal
        openModal={openModal}
        handleCloseModal={handleCloseModal}
        storeEmail={LoginGetDashBoardRecordJson?.data?.email}
        selectedDateRange={selectedDateRange}
        endPointObj={endPointObj[selectedReport]}
      />
    </div>
  );
};

export default NewSalesReportMain;
